import { loadStripe } from '@stripe/stripe-js';

const stripePublicKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
const isStripeTestMode = stripePublicKey?.startsWith('pk_test_');

export const stripePromise = stripePublicKey
	? loadStripe(
			stripePublicKey,
			isStripeTestMode
				? {
						developerTools: {
							assistant: {
								enabled: true,
							},
						},
					}
				: undefined,
		)
	: null;

export { isStripeTestMode };
